const hasChildren = node => {
  if (node?.children?.length) return true;
  return false;
};

const isMobileElement = flags => {
  // In case false is actually returned. Checking specifically, otherwise undefined  would qualify.
  if (flags?.hideFromMobile === false) return true;
  // Should be displayed in both desktop and mobile.
  if (flags?.hideFromMobile === undefined && flags?.hideFromDesktop === undefined) return true;
  // Should be hidden from desktop.
  if (flags?.hideFromDesktop === true) return true;
  // Default.
  return false;
};

const processElement = element => {
  if (isMobileElement(element.flags)) {
    /*
      The differentiating factor between a group/container and nodes of the other type is that
      groups/containers are not displayable by themselves, which is why the return value of
      them are their children, whom will replace them in their spot of the current data, while
      the return value of the other types are the nodes plus their filtered children.
    */
    if (element.type === 'group' || element.type === 'container') {
      if (hasChildren(element)) {
        return element.children.flatMap(processElement);
      } else {
        /*
          This shouldn't happen, but it is a precaution since it is authored.
          Yes, we should keep it because it really did happen before.
         */
        return [];
      }
    } else if (hasChildren(element)) {
      const mobileFriendlyChildren = element.children.flatMap(processElement);
      /*
        Intermediate node within the tree with mobile children, which leads this to be a submenu.
        However, there are situations where none of the children are mobile friendly, but this
        element is and has a URL, which lends this element to being a leaf node that is displayed.
       */
      if (mobileFriendlyChildren.length || element.url) {
        return { ...element, children: mobileFriendlyChildren };
      }
    } else {
      if (element.url) return element;
    }
  }
  return [];
};

/**
 * Retrieve the items whose whose content is intended to be displayed in a mobile setting.
 * @param {Object} mainMenu menu data.
 * @returns Array<Object> items that qualify as being mobile items.
 */
export const getMobileMenuItems = mainMenu => {
  // Utilizing flatMap due to the structure of the data, which can expand or contract.
  return mainMenu?.children?.flatMap(processElement) || [];
};

/**
 * Function to check if the content item is a header
 * @param {Object} contentItem - content
 * @returns Boolean - true if the content type is header else false
 */
export const isHeader = contentItem => {
  return contentItem?.type === 'header';
};

/**
 * Takes the array of separates it into subsections. If the element is a header, this is an
 * indicator that it is a new section. A section can be composed of all non-headers elements
 * or a header element, followed by 0 or more non-headers elements.
 *
 * @param {Array<Object>} childContent
 * @returns {Array<Array<Object>>}
 */
export const generateMenuSections = childContent => {
  const aggregatedSections = [];
  if (Array.isArray(childContent) && childContent.length) {
    aggregatedSections.push([childContent[0]]);
    for (const child of childContent.slice(1)) {
      if (!isHeader(child)) {
        aggregatedSections[aggregatedSections.length - 1].push(child);
      } else {
        aggregatedSections.push([child]);
      }
    }
  }
  return aggregatedSections;
};
